var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhillipines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 512,
    viewBox: "0 0 513 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_103_9080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0H512.5V256H0.5V0Z",
    fill: "#0038A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 256H512.5V512H0.5V256Z",
    fill: "#CE1126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.9 256L0.5 512V0",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7 44.3999L41.1 57.6999L59 47.8999L51 66.5999L66 80.5999L45.5 78.8999L36.9 97.2999L32.2 77.4999L12 74.8999L29.5 64.3999L25.7 44.3999ZM372.6 229L373 249.3L392.3 256L373 262.7L372.6 283L360.3 266.8L340.8 272.8L352.5 256L340.8 239.3L360.3 245.2L372.6 229ZM37 414.7L45.6 433.1L65.9 431.4L51.1 445.4L59 464.1L41.1 454.3L25.7 467.6L29.6 447.6L12.1 437.1L32.3 434.5L37 414.7ZM159.4 148L152.8 154.6L156 204.9L152.7 205.2L146.7 159.3L141.2 164.7L149.4 205.7C142.82 207.03 136.567 209.647 131 213.4L107.7 178.6H100L128.2 215.4L125.7 217.5L92.4 179.5H83V189L121 222.3L118.8 224.8L82 196.6V204.3L116.8 227.6C113.08 233.173 110.498 239.426 109.2 246L68.2 237.8L62.7 243.3L108.7 249.3L108.3 252.7L58 249.4L51.3 256L58 262.6L108.3 259.4L108.6 262.7L62.7 268.7L68.1 274.2L109.1 266C110.431 272.58 113.047 278.833 116.8 284.4L82 307.7V315.4L118.8 287.2L120.9 289.7L82.9 323V332.4H92.5L125.8 294.4L128.3 296.6L100.1 333.4H107.8L131.1 298.6C136.672 302.322 142.925 304.905 149.5 306.2L141.3 347.2L146.8 352.7L152.8 306.7L156.1 307.1L152.9 357.4L159.5 364.1L166.1 357.4L162.9 307.1L166.2 306.8L172.2 352.7L177.7 347.3L169.5 306.3C176.08 304.969 182.333 302.353 187.9 298.6L211.2 333.4H218.9L190.5 296.6L193 294.5L226.3 332.5H235.7V323L197.7 289.7L199.9 287.2L236.7 315.4V307.7L201.9 284.4C205.62 278.827 208.202 272.574 209.5 266L250.5 274.2L256 268.7L210 262.7L210.4 259.4L260.7 262.6L267.4 256L260.7 249.4L210.4 252.7C210.4 251.5 210.2 250.4 210.1 249.3L256 243.3L250.6 237.8L209.6 246C208.269 239.42 205.653 233.167 201.9 227.6L236.7 204.3V196.6L199.9 224.8L197.8 222.3L235.8 189V179.6H226.3L193 217.6L190.5 215.4L218.7 178.6H211L187.7 213.4C182.127 209.68 175.874 207.097 169.3 205.8L177.5 164.8L172 159.3L166 205.3L162.7 204.9L165.9 154.6L159.4 148Z",
    fill: "#FCD116"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_103_9080"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhillipines);
export default __webpack_public_path__ + "static/media/phillipines.f4a8a88f099c71fbd3116afed3869ff6.svg";
export { ForwardRef as ReactComponent };